import React, { useState, useEffect } from 'react';
import TableExample from './TableExample';
import { useScript } from "@uidotdev/usehooks";
import { setDefaultResultOrder } from 'dns';

// if using typescript include args
interface PipeUIArgs {
  authToken: string | null;
  configID: string;
  environment?: "sandbox" | "production";
  scrollParent?: string;
  externalID?: string;
  onAuthorizeDataShare: ({
    onSuccess,
    onFailure,
  }: {
    onSuccess: ({ authToken }: { authToken: string }) => void;
    onFailure: ({ message }: { message?: string }) => void;
  }) => Promise<void>;
}

// if using typescript declare window.startPipeUI function
declare global {
  interface Window {
    startPipeUI: (args: PipeUIArgs) => {
      destroy: () => void;
      setAuthToken: (authToken: string) => void;
    };
  }
}

interface UsersProps {
  email: string;
  business: string;
  loggedIn: boolean;
  token: string;
  setLoggedIn: React.Dispatch<React.SetStateAction<boolean>>;
  setEmail: React.Dispatch<React.SetStateAction<string>>;
  setBusiness: React.Dispatch<React.SetStateAction<string>>;
  baseUrl: string;
}

const Embedded: React.FC<UsersProps> = ({ email, loggedIn, token, setLoggedIn, setEmail,baseUrl,business, setBusiness }) => {
  const [userData, setUserData] = useState<{ Items: Array<{ email: string }> }>({ Items: [] });
  const [authToken, setAuthToken] = useState<string>("");  // Initialize as an empty string
  const [loading, setLoading] = useState<boolean>(true); // Loading state
  const [inputValue, setInputValue] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState<string>('');

  


  useEffect(() => {
    const fetchData = async () => {
      setLoading(true); // Set loading to true before fetching
      try {
        const response = await fetch(baseUrl + 'authenticationToken?business_id=' + business, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'jwt-token': token,
          },
        });

        const data = await response.json();
        console.log(data);

        if (data.token) {
          setAuthToken(data.token); // Update state with fetched data
          console.error("Authtoken set");
          setErrorMessage("");
        } else {
          console.error(data);

          if(data.message) {
            setErrorMessage("An error occurred:" + data.message);
          }
          else{
            setErrorMessage("An error occurred");
          }

     


        }
      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        setLoading(false); // Set loading to false after fetching
      }
    };

    fetchData(); // Call the fetchData function
  }, [token, business]); // Dependency array: re-fetch only if token changes

  const status = useScript("https://sdk.pipe.com/embed.js");

  useEffect(() => {
    if (status !== "ready" || authToken == "") return;

    const connection = window.startPipeUI({
      // replace with your configID provided by Pipe
      configID: "pius_11W8J6mHkTW1TfZz",
      authToken: authToken,
      environment: "sandbox",
      // externalID if utilizing waitlist for null auth tokens
     // externalID: "1234",
      onAuthorizeDataShare: async ({ onSuccess, onFailure }) => {
        // // fetch auth token from your server
        // do
        // try {
        //   const { authToken } = await fetch(
        //     "https://your.backend.com/capital/start-data-sync"
        //   );
        // onSuccess({ authToken });
        // } catch (e) {
        onSuccess({ authToken });
        // }
      },
    });

    // update auth token if necessary
    // connection?.setAuthToken("YOUR_AUTH_TOKEN");

    // if destroy/re-render is necessary
    return () => {
      connection?.destroy();
    };
  }, [status, authToken]);
 
  // Function to handle input change with explicit typing
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value);
  };

  // Function to handle button click
  const handleButtonClick = () => {
    setBusiness(inputValue);
    setInputValue(''); // Optionally clear the input field after setting the state
  };


  return (
    <>
    <div className={'pipe-container'}>
      <div className={'right-aligned-div'}>
      <br />
      <input
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        placeholder="Enter business id"
        className="inputBox"/>
      <input className="inputButton" type="button" onClick={handleButtonClick} value="Update" /><br />
      {errorMessage}
      </div>
      <br />
      <div id="pipe-ui" className={'pipe-container'}></div>

    </div>
    
    </>
  );
};

export default Embedded;
